<template>

  <b-modal
      id="modal-add-company"
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      hide-footer
      centered
      size="lg"
      v-model="modal.show"
      body-class="modal-body-content"
      :style="{ padding: '0px !important' }"
  >
    <b-overlay :show="loading" rounded="lg" opacity="0.6" class="w-100 mt-1">
      <div class="p-2">
        <b-row class="mb-1">
          <h3 class="pl-1">Você possui rascunhos em andamento. Deseja continuar a edição?</h3>
        </b-row>
        <template>
          <div>
            <b-table
                :items="itens"
                :fields="campos"
                bordered
                small
                responsive
                sticky-header="300px"
            >
            <template #cell(numero_pedido)="data">
              #{{ data.value }}
            </template>
            <template #cell(data_processamento)="data">
              {{ formatDataHora(data.value) }}
            </template>
              <template #cell(acao)="data">
              <b-button
                  @click.prevent="editarRascunho(data.item.id_pedido)"
                  squared
                  variant="none"
                  class="m-0 text-dark-blue"
              >
                <feather-icon size="15" icon="EditIcon" />
              </b-button>
            </template>
            </b-table>
          </div>
        </template>
        <b-row class="mt-3">
          <b-col class="d-flex align-items-center gap-2">
            <b-button
                variant="custom-blue"
                class="button-config"
                @click="novoRascunho"
            >
              Nova Adesão
            </b-button>

            <b-button
                variant="outline-danger"
                class="button-config ml-2"
                @click="fecharModal"
            >
              Cancelar
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-overlay>
  </b-modal>
</template>
<script>

import {BAlert, BCol, BFormGroup, BFormInput, BModal, BRow, BTab, BTabs, BImg,BForm,BButton, BOverlay,BFormRadioGroup, BTable, BButtonGroup} from "bootstrap-vue";
import moment from "moment/moment";

export default {
  components: {
    BAlert,
    BFormGroup,
    BRow,
    BCol,
    BFormInput,
    BModal,
    BTab, BTabs, BImg, BForm,
    BButton,
    BOverlay,
    BFormRadioGroup,BTable,
    BButtonGroup
  },
  props: {
    showModal: {
      required: true,
      type: Boolean,
    },
    rascunhos: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      modal: {
        show: this.showModal,
        empresaSelecionada: null,
        empresas: [],
      },
      loading: false,
      campos: [
        { key: "numero_pedido", label: "Pedido" },
        { key: "nome_campanha", label: "Campanha" },
        { key: "realizado_por", label: "Realizado Por" },
        { key: "data_processamento", label: "Iniciado" },
        { key: "acao", label: "" },
      ],
      itens: this.rascunhos
    }
  },
  methods: {
    novoRascunho() {
      this.$emit('formSubmit')
    },
    editarRascunho(idPedido) {
      this.$emit('editarRascunho', idPedido)
    },
    fecharModal() {
      this.$emit('fecharModalRascunhos')
    },
    formatDataHora(data) {
      return data ? moment(data).format('DD/MM/YYYY HH:mm') : '--'
    },
  }
}
</script>
